import { create } from 'zustand';

import { UUID } from '@/types';

type SelectedItemsState = {
  include: UUID[];
  exclude: UUID[];
  toggleAllActived: boolean;
};

type SelectedItemsAction =
  | { type: 'include'; payload: SelectedItemsState['include'] }
  | { type: 'exclude'; payload: SelectedItemsState['exclude'] }
  | { type: 'toggleId'; payload: UUID }
  | { type: 'resetIds' }
  | { type: 'toggleAll' }
  | { type: 'removeToggleAll' }
  | { type: 'reset' };

type Dispatch = {
  dispatch: (action: SelectedItemsAction) => void;
};

function initialState(): SelectedItemsState {
  return {
    include: [],
    exclude: [],
    toggleAllActived: false,
  };
}

function reducer(state: SelectedItemsState, action: SelectedItemsAction) {
  switch (action.type) {
    case 'include':
      return { ...state, [action.type]: action.payload };
    case 'exclude':
      return { ...state, [action.type]: action.payload };
    case 'toggleAll': {
      return {
        ...state,
        toggleAllActived: !state.toggleAllActived,
      };
    }
    case 'toggleId': {
      return {
        ...state,
        include: state.include.includes(action.payload)
          ? state.include.filter(id => id !== action.payload)
          : [...state.include, action.payload],
      };
    }
    case 'removeToggleAll': {
      return {
        ...state,
        toggleAllActived: false,
      };
    }
    case 'resetIds':
      return {
        ...state,
        include: [],
        exclude: [],
      };
    case 'reset':
      return {
        include: [],
        exclude: [],
        toggleAllActived: false,
      };

    default:
      return state;
  }
}

export const useSelectedItemsStore = create<SelectedItemsState & Dispatch>(set => ({
  ...initialState(),
  dispatch: (action: SelectedItemsAction) => set(state => reducer(state, action)),
}));
